const processedImgSources = [];

export default {
    init() {
        /**
         * @description if image can't be loaded from server- display a "no image found" image
         * with a text of image URL,
         * @see cartridges/int_acf_core/cartridge/sass/modules_system/common/_modules_base.scss .lazyloaded rules
         */
        window.addEventListener('error', function(e) {
            if (e.target.nodeName === 'IMG' && processedImgSources.indexOf(e.target.currentSrc) === -1) {
                processedImgSources.push(e.target.currentSrc);
                e.target.dataset.src = e.target.currentSrc;
            }
        }, true);
    }
};
